var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.exBannerFiles),function(banner,idx){return _c('swiper-slide',{key:idx},[_c('img',{attrs:{"src":banner.file_path}})])}),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }